(function () {
  const isRTL = getComputedStyle(document.body).direction === "rtl";

  let sections = [];
  let ticking = false;

  function initScrollProducts() {
    sections = [...document.querySelectorAll(".section-scroll-products")];

    sections.forEach((section) => {
      if (section.classList.contains("scroll_initialized")) return;
      section.classList.add("scroll_initialized");

      const child = section.querySelector(".scroll-products");
      const productCard = section.querySelector(".scroll-products__item");
      const wrapper = section.querySelector(".scroll-products__wrapper");

      if (!child || !productCard || !wrapper) return;

      const childBefore = window.getComputedStyle(child, "::before");
      const slideHeight = parseFloat(childBefore.height);

      const updateMinHeight = () => {
        wrapper.style.maxHeight = `${productCard.offsetHeight}px`;

        let productCardHeight = productCard.offsetHeight + 96;
        if (productCardHeight < slideHeight) {
          productCardHeight = slideHeight;
        }

        if (parseInt(child.style.minHeight) !== productCardHeight) {
          child.style.minHeight = `${productCardHeight}px`;
        }
      };

      updateMinHeight();
      section._updateMinHeight = updateMinHeight;
    });

    onScroll();
  }

  function updateSection(section) {
    const parent = section.querySelector(".scroll-products__container");
    const child = section.querySelector(".scroll-products");
    const innerDiv = section.querySelector(".scroll-products__products");

    if (!parent || !child || !innerDiv) return;

    const productsCount = +child.dataset.productsCount;
    const isSingleProduct = productsCount === 1;

    const parentRect = parent.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (parentRect.bottom <= 0 || parentRect.top >= viewportHeight) return;

    const progress =
      (viewportHeight - parentRect.top) /
      (viewportHeight + parentRect.height);

    const scrolled = Math.min(Math.max(progress, 0), 1);

    const isSmallScreen = window.innerWidth < 990;
    const isMediumScreen = window.innerWidth < 1360;

    let translateX = -50;
    let translateY = -115 + 110 * scrolled;

    if (!isSmallScreen) {
      if (productsCount === 4) {
        translateY = -50;
        translateX = !isMediumScreen
          ? 70 - 70 * scrolled
          : 76 - 76 * scrolled;
      } else if (!isSingleProduct) {
        translateY = -50;
        translateX = !isMediumScreen
          ? 60 - 60 * scrolled
          : 67 - 67 * scrolled;
      } else {
        translateX = 0;
        translateY = -50 * scrolled;
      }

      innerDiv.style.transform = `translate(${
        isRTL ? -translateX : translateX
      }%, ${translateY}%)`;
    } else {
      const wrapper = section.querySelector(".scroll-products__wrapper");

      const diffHeight =
        (child.offsetHeight - wrapper.offsetHeight) / 2;
      const endPoint = diffHeight - 15;
      const startPoint = -(diffHeight + innerDiv.offsetHeight + 1);

      translateY = startPoint + (endPoint - startPoint) * scrolled;

      innerDiv.style.transform = `translate(${translateX}%, ${translateY}px)`;
    }
  }

  function onScroll() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      sections.forEach(updateSection);
      ticking = false;
    });
  }

  function onResize() {
    sections.forEach((section) => {
      section._updateMinHeight?.();
      updateSection(section);
    });
  }

  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", onResize);

  document.addEventListener("DOMContentLoaded", initScrollProducts);
  document.addEventListener("shopify:section:load", initScrollProducts);
})();
